
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

parcelRequire("kM5jX");
parcelRequire("haS5e");
parcelRequire("fQwj1");
parcelRequire("a7nVE");
parcelRequire("1fSMk");

var $lXnOV = parcelRequire("lXnOV");

var $7IoHk = parcelRequire("7IoHk");

"use strict";
const $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE = 3;
let $75d8a6bcc5c56d80$var$currentPage = 1;
const $75d8a6bcc5c56d80$var$emptyList = document.querySelector(".empty-list");
const $75d8a6bcc5c56d80$var$shoppingGallery = document.querySelector(".shopping-gallery");
const $75d8a6bcc5c56d80$var$btnFirstPage = document.querySelector(".btn-first-page");
const $75d8a6bcc5c56d80$var$btnPrevPage = document.querySelector(".btn-prev-page");
const $75d8a6bcc5c56d80$var$btnNextPage = document.querySelector(".btn-next-page");
const $75d8a6bcc5c56d80$var$btnLastPage = document.querySelector(".btn-last-page");
const $75d8a6bcc5c56d80$var$paginationContainer = document.querySelector(".shopping-pagination__btn-second");
const $75d8a6bcc5c56d80$var$shoppingButtons = document.querySelector(".shopping-pagination");
const $75d8a6bcc5c56d80$var$getFromLocalStorage = ()=>{
    const storedBooks = JSON.parse(localStorage.getItem("books")) || [];
    const storedBooksId = storedBooks.map((book)=>book._id);
    return storedBooksId;
};
const $75d8a6bcc5c56d80$var$renderBook = (bookData)=>{
    const shopItem = document.createElement("div");
    shopItem.classList.add("shop");
    const btnTrash = document.createElement("button");
    btnTrash.classList.add("shop__btn-trash");
    shopItem.appendChild(btnTrash);
    btnTrash.addEventListener("click", ()=>{
        const shopItem = btnTrash.closest(".shop");
        if (shopItem) {
            const bookId = bookData._id;
            const storedBooks = JSON.parse(localStorage.getItem("books"));
            const updatedBooks = storedBooks.filter((book)=>book._id !== bookId);
            localStorage.setItem("books", JSON.stringify(updatedBooks));
            shopItem.remove();
            if (updatedBooks.length === 0) {
                $75d8a6bcc5c56d80$var$emptyList.classList.remove("hidden");
                $75d8a6bcc5c56d80$var$shoppingButtons.classList.add("hidden");
            } else $75d8a6bcc5c56d80$var$adjustPageAfterDeletion(updatedBooks);
        }
    });
    const shopImg = document.createElement("img");
    shopImg.classList.add("shop__photo");
    shopImg.src = bookData.book_image;
    shopItem.appendChild(shopImg);
    const markup = `
    <h2 class="shop__title">${bookData.title}</h2>
    <p class="shop__category">${bookData.list_name}</p>
    <p class="shop__text">${bookData.description}</p>
  <div class="author-inline">
      <p class="shop__author">${bookData.author}</p>
      <div class="shop__amazon-book">
        <a class="shop__amazon" href="${bookData.amazon_product_url}" target="_blank"></a>
        <div class="shop__book-icon"></div>
      </div>
    </div>
  `;
    const shopDescriptionDetails = document.createElement("div");
    shopDescriptionDetails.classList.add("shop__content");
    shopDescriptionDetails.innerHTML = markup;
    shopItem.appendChild(shopDescriptionDetails);
    $75d8a6bcc5c56d80$var$shoppingGallery.appendChild(shopItem);
};
const $75d8a6bcc5c56d80$var$adjustPageAfterDeletion = (updatedBooks, start, end)=>{
    const totalPages = Math.ceil(updatedBooks.length / $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE);
    if ($75d8a6bcc5c56d80$var$currentPage > totalPages) $75d8a6bcc5c56d80$var$currentPage = totalPages;
    start = ($75d8a6bcc5c56d80$var$currentPage - 1) * $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE;
    end = start + $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE;
    $75d8a6bcc5c56d80$var$renderPageNumbers(totalPages);
    $75d8a6bcc5c56d80$var$loadPage($75d8a6bcc5c56d80$var$currentPage, start, end);
};
const $75d8a6bcc5c56d80$var$loadPage = async (pageNumber, start, end)=>{
    const storedBooksId = $75d8a6bcc5c56d80$var$getFromLocalStorage();
    if (start === undefined || end === undefined) {
        start = (pageNumber - 1) * $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE;
        end = start + $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7IoHk))).Loading.circle("Loading...", {
        backgroundColor: "rgba(0,0,0,0.8)",
        svgColor: "#fff"
    });
    $75d8a6bcc5c56d80$var$shoppingGallery.innerHTML = "";
    if (storedBooksId.length === 0) {
        $75d8a6bcc5c56d80$var$emptyList.classList.remove("hidden");
        $75d8a6bcc5c56d80$var$shoppingButtons.classList.add("hidden");
        (0, (/*@__PURE__*/$parcel$interopDefault($7IoHk))).Loading.remove();
        return;
    }
    $75d8a6bcc5c56d80$var$emptyList.classList.add("hidden");
    for(let i = start; i < end && i < storedBooksId.length; i++){
        const bookDetails = await (0, $lXnOV.fetchBookById)(storedBooksId[i]);
        $75d8a6bcc5c56d80$var$renderBook(bookDetails);
    }
    $75d8a6bcc5c56d80$var$btnPrevPage.disabled = $75d8a6bcc5c56d80$var$currentPage === 1;
    $75d8a6bcc5c56d80$var$btnFirstPage.disabled = $75d8a6bcc5c56d80$var$currentPage === 1;
    $75d8a6bcc5c56d80$var$btnNextPage.disabled = $75d8a6bcc5c56d80$var$currentPage === Math.ceil(storedBooksId.length / $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE);
    $75d8a6bcc5c56d80$var$btnLastPage.disabled = $75d8a6bcc5c56d80$var$currentPage === Math.ceil(storedBooksId.length / $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE);
    $75d8a6bcc5c56d80$var$renderPageNumbers(Math.ceil(storedBooksId.length / $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE));
    (0, (/*@__PURE__*/$parcel$interopDefault($7IoHk))).Loading.remove();
};
const $75d8a6bcc5c56d80$var$renderPageNumbers = (totalPages)=>{
    $75d8a6bcc5c56d80$var$paginationContainer.innerHTML = "";
    for(let i = 1; i <= totalPages; i++){
        const btn = document.createElement("button");
        btn.classList.add("shopping-pagination__btn");
        btn.classList.add($75d8a6bcc5c56d80$var$currentPage === i ? "shopping-pagination__btn-black-background" : "shopping-pagination__btn-white-color");
        btn.textContent = i;
        btn.addEventListener("click", ()=>{
            $75d8a6bcc5c56d80$var$currentPage = i;
            $75d8a6bcc5c56d80$var$loadPage($75d8a6bcc5c56d80$var$currentPage);
        });
        $75d8a6bcc5c56d80$var$paginationContainer.appendChild(btn);
    }
};
$75d8a6bcc5c56d80$var$btnFirstPage.addEventListener("click", ()=>{
    $75d8a6bcc5c56d80$var$currentPage = 1;
    $75d8a6bcc5c56d80$var$loadPage($75d8a6bcc5c56d80$var$currentPage);
});
$75d8a6bcc5c56d80$var$btnPrevPage.addEventListener("click", ()=>{
    $75d8a6bcc5c56d80$var$currentPage = Math.max(1, $75d8a6bcc5c56d80$var$currentPage - 1);
    $75d8a6bcc5c56d80$var$loadPage($75d8a6bcc5c56d80$var$currentPage);
});
$75d8a6bcc5c56d80$var$btnNextPage.addEventListener("click", ()=>{
    const storedBooks = $75d8a6bcc5c56d80$var$getFromLocalStorage();
    $75d8a6bcc5c56d80$var$currentPage = Math.min($75d8a6bcc5c56d80$var$currentPage + 1, Math.ceil(storedBooks.length / $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE));
    $75d8a6bcc5c56d80$var$loadPage($75d8a6bcc5c56d80$var$currentPage);
});
$75d8a6bcc5c56d80$var$btnLastPage.addEventListener("click", ()=>{
    const storedBooks = $75d8a6bcc5c56d80$var$getFromLocalStorage();
    $75d8a6bcc5c56d80$var$currentPage = Math.ceil(storedBooks.length / $75d8a6bcc5c56d80$var$ITEMS_PER_PAGE);
    $75d8a6bcc5c56d80$var$loadPage($75d8a6bcc5c56d80$var$currentPage);
});
$75d8a6bcc5c56d80$var$loadPage($75d8a6bcc5c56d80$var$currentPage);


parcelRequire("2DTLi");
parcelRequire("eNCUi");


//# sourceMappingURL=shopping-list.daa4607a.js.map
